class LoginMenuSwitcher {
    constructor() {
        this.menuItem = document.querySelector('.login-menu-item a .wp-block-navigation-item__label strong');
        this.init();
    }

    init() {
        if (document.body.classList.contains('logged-in')) {
            this.switchToAccount();
        } else {
            this.switchToLogin();
        }
    }

    switchToAccount() {
        if (this.menuItem) {
            this.menuItem.textContent = 'Account';

        }
    }

    switchToLogin() {
        if (this.menuItem) {
            this.menuItem.textContent = 'Login';

        }
    }
}

export default LoginMenuSwitcher;